export const GET_ABBVIE_ID_CONFIGURED_APP_LIST = `query($filter: IccAppConfigurationFilter, $first:Int, $last:Int, $after:Cursor, $before:Cursor) {
    allIccAppConfigurations(filter:$filter, first:$first, last:$last, after:$after, before:$before) {
        nodes {
            id
            appName
          	aemAppEnvironmentPath
        }
        totalCount
        pageInfo{
          hasNextPage
          hasPreviousPage
          startCursor 
          endCursor
        }
  	}
}`;

export const CREATE_ABBVIE_ID_CONFIGURED_APP = `mutation($iccAppConfiguration: IccAppConfigurationInput!){
	createIccAppConfiguration(input: {
    iccAppConfiguration: $iccAppConfiguration
  }) {
    iccAppConfiguration {
        appName
        aemAppEnvironmentPath
    }
  }
}`;

export const UPDATE_ABBVIE_ID_CONFIGURED_APP = `mutation($id: UUID!, $iccAppConfiguration: IccAppConfigurationPatch!) {
  updateIccAppConfigurationById(input:{
    id:$id,
    iccAppConfigurationPatch: $iccAppConfiguration
  }) {
    iccAppConfiguration {
      id
      appName
			aemAppEnvironmentPath
    }
  }
}`;

export const DELETE_ABBVIE_ID_CONFIGURED_APP = `mutation($id:UUID!) {
	deleteIccAppConfigurationById(input:{id: $id}) {
        iccAppConfiguration {
            id
        }
    }
}`;
